import Link from "next/link";
import React from "react";
import {Card} from "react-bootstrap";

const CartNoProducts = () => {
    return (
        <Card className="bg-white shadow-sm mt-4 mb-5">
            <Card.Body>
                <p className="py-2 m-0">
                    Cosul tau de cumparaturi nu contine produse. Pentru a adauga produse in cos te rugam sa te intorci
                    <Link href={"/"}> in magazin.</Link>
                </p>
            </Card.Body>
        </Card>
    );
};

export default CartNoProducts;
